import { SET_SEARCH_STATE } from './actionTypes';

export const changeSearchState = (state) => ({
  type: SET_SEARCH_STATE,
  state,
});
